import { Search } from "lucide-react";
import { PRIORITIES, STATUSES, REPLIES } from "./constants";

export default function FilterBar({ filters, setFilters, count }) {
  const set = (k) => (e) => setFilters({ ...filters, [k]: e.target.value });
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative flex-1 min-w-[220px]">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "var(--muted)" }} />
        <input data-testid="search-contacts-input" className="input pl-9" placeholder="Search name, label, city, fit notes…" value={filters.q} onChange={set("q")} />
      </div>
      <select data-testid="filter-priority-select" className="select w-auto" value={filters.priority} onChange={set("priority")}>
        <option value="">All priorities</option>
        {PRIORITIES.map((p) => <option key={p}>{p}</option>)}
      </select>
      <select data-testid="filter-status-select" className="select w-auto" value={filters.status} onChange={set("status")}>
        <option value="">All statuses</option>
        {STATUSES.map((s) => <option key={s}>{s}</option>)}
      </select>
      <select data-testid="filter-reply-select" className="select w-auto" value={filters.reply} onChange={set("reply")}>
        <option value="">Any reply</option>
        {REPLIES.map((s) => <option key={s} value={s}>Reply: {s}</option>)}
      </select>
      <select data-testid="sort-select" className="select w-auto" value={filters.sort} onChange={set("sort")}>
        <option value="priority">Sort: priority tier</option>
        <option value="score">Sort: reply score</option>
      </select>
      <span className="mono text-xs ml-1" style={{ color: "var(--muted)" }} data-testid="results-count">{count} shown</span>
    </div>
  );
}
